<template>
    <v-card>
        <loading-component :value="loading"></loading-component>
        <v-form ref="personal_info_form">
            <v-container :fluid="true" style="padding:0">
                <v-layout row wrap>
                    <v-flex xs4>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field label="First Name" v-model="captain.first_name"/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Last Name" v-model="captain.last_name"/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Phone Number" v-model="captain.username" disabled/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Whatsapp" v-model="captain.whatsapp_number"/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Email" v-model="captain.email"/>
                            </v-flex>
                            <v-flex xs12>
                                <ChooseGender label="Gender" :value="captain.gender"
                                              @input="val => captain.gender = val"/>
                            </v-flex>
                            <v-flex xs12>
                                <ChooseDate label="Birthday" v-model="captain.birthday"/>
                            </v-flex>
                            <v-flex xs12>
                                <ChooseDate label="Driving Certificate (Start)"
                                            v-model="captain.driving_certificate_start_date"/>
                            </v-flex>
                            <v-flex xs12>
                                <ChooseDate label="Driving Certificate (End)"
                                            v-model="captain.driving_certificate_end_date"/>
                            </v-flex>
                            <v-flex xs12>
                                <choose-location-multi label="Location"
                                                       :multi="false"
                                                       :rules="[val => !!val || 'Required']"
                                                       v-model="captain.location"
                                                       return-object/>
                            </v-flex>
                            <v-flex xs12>
                                <choose-bank-multi label="Bank"
                                                   :multi="false"
                                                   v-model="captain.bank"
                                                   return-object/>
                            </v-flex>
                            <v-flex xs12>
                                <choose-nationality-multi label="Nationality"
                                                          :multi="false"
                                                          :rules="[val => !!val || 'Required']"
                                                          v-model="captain.nationality"
                                                          return-object/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs8>
                        <v-layout row wrap>
                            <v-flex xs6 v-for="(imageInput,i) of imageInputs" :key="imageInput">
                                <div class="px-3">
                                    <v-img :src="files[imageInput].url ? files[imageInput].url : api.GET_IMAGE(captain[imageInput])"
                                           width="60%"
                                           v-if="files[imageInput].url || captain[imageInput]"/>
                                    <input type="file" style="display: none" ref="imageInput"
                                           accept="image/*,application/pdf" @change="onFilePicked(i)">
                                    <v-text-field :label="'Upload ' +imageInput"
                                                  @click='$refs.imageInput[i].click()'
                                                  v-model='files[imageInput].name' :rules="fileRules"
                                                  append-icon='attach_file'
                                                  readonly/>
                                </div>
                            </v-flex>
                            <v-flex xs6 v-if="hasPermission('CAN_ACTIVATE_CAPTAIN_WITHOUT_NO_CONVICTION')">
                                <v-checkbox color="primary" v-model="background_checked" label="Background Checked?"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </v-card>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseGender from "@/components/wasilni/input/ChooseGender";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseLocationMulti from "@/components/wasilni/input/ChooseLocationMulti";
    import ChooseBankMulti from "@/components/wasilni/input/ChooseBankMulti";
    import ChooseNationalityMulti from "@/components/wasilni/input/ChooseNationalityMulti";

    const imageInputs = ['id_card_front', 'id_card_back', 'driving_certificate_front', 'driving_certificate_back', 'no_conviction', 'profile_image'];

    export default {
        name: "PersonalInfo",
        components: {
            ChooseDate,
            ChooseGender,
            LoadingComponent,
            ChooseLocationMulti,
            ChooseBankMulti,
            ChooseNationalityMulti
        },
        data() {
            return {
                loading: false,
                captain: {},
                files: Object.assign(...imageInputs.map(imageInput => ({
                    [imageInput]: {}
                }))),
                fileRules: [
                    v => !!v || 'File is required',
                ],
                numberRules: [
                    v => !!v || 'Required field',
                    v => /^[0-9]*$/.test(v) || 'invalid value'
                ],
                captain_id: null,
                background_checked: false
            }
        },
        computed: {
            imageInputs() {
                if (!this.background_checked)
                    return imageInputs;
                else
                    return imageInputs.filter(i => i !== 'no_conviction');
            },
        },
        watch: {
            "captain.location": function (val) {
                if (!val)
                    this.captain.location_id = null;
                else
                    this.captain.location_id = val.id;
            },
            "captain.bank": function (val) {
                if (!val)
                    this.captain.bank_id = null;
                else
                    this.captain.bank_id = val.id;
            },
            "captain.nationality": function (val) {
                if (!val)
                    this.captain.nationality_id = null;
                else
                    this.captain.nationality_id = val.id;
            },

        },
        methods: {
            reset() {
                this.captain = {};
                this.files = Object.assign(...imageInputs.map(imageInput => ({
                    [imageInput]: {}
                })));
                this.$refs.personal_info_form.reset();
            },
            update(captain_id) {
                this.reset();
                this.captain_id = captain_id;
                this.loading = true;
                this.axios.get(`captain/${captain_id}`)
                    .then(res => {
                        this.captain = res.data.data;
                        for (let imageInput of imageInputs) {
                            if (this.captain[imageInput])
                                this.files[imageInput] = {name: imageInput};
                        }
                    })
                    .catch(err => console.log(err.message))
                    .finally(() => this.loading = false);
            },
            async submit() {
                const formData = new FormData();

                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                };

                if (!this.$refs.personal_info_form.validate()) {
                    this.$emit('done');
                    return;
                }

                this.loading = true;

                for (let field in this.captain)
                    if (this.captain.hasOwnProperty(field) && imageInputs.indexOf(field) === -1 && this.captain[field] !== null)
                        formData.append(`captain[${field}]`, this.captain[field]);

                for (let imageInput of this.imageInputs) {
                    if (imageInput === 'no_conviction' && this.background_checked)
                        continue;
                    if (this.files[imageInput].changed)
                        formData.append(`captain[${imageInput}]`, this.files[imageInput].file);
                }
                formData.append('_method', 'PUT');
                console.log(formData);
                await this.axios.post(`captain/${this.captain_id}`, formData, config)
                    .then(() => this.$emit('next_step'))
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    }).finally(() => this.$emit('done'));

                this.loading = false;
            },
            onFilePicked(index) {
                const files = this.$refs.imageInput[index].files;
                const type = this.imageInputs[index];
                if (files[0] !== undefined) {
                    this.files[type].changed = true;
                    this.files[type].name = files[0].name;
                    if (this.files[type].name.lastIndexOf('.') <= 0) {
                        return;
                    }
                    const fr = new FileReader();
                    fr.readAsDataURL(files[0]);
                    fr.addEventListener('load', () => {
                        this.$set(this.files[type], 'url', fr.result);
                        // this.files[type].url = fr.result;
                        this.files[type].file = files[0];
                    })
                } else {
                    this.files[type] = {};
                }
            },
        }
    }
</script>

<style scoped>

</style>
